import { RECIPIENT_FIELD_STATUS } from "../config/sale-reopen-request-modal.config.js";

/**
 * Resolve o status de render do Select de destinatários.
 * @param {{ optionsLoading: boolean, optionsError: string|null|undefined }} state
 * @returns {string}
 */
export function resolveRecipientFieldStatus({ optionsLoading, optionsError }) {
  if (optionsLoading) return RECIPIENT_FIELD_STATUS.loading;
  if (optionsError) return RECIPIENT_FIELD_STATUS.error;
  return RECIPIENT_FIELD_STATUS.ready;
}
